import { render, staticRenderFns } from "./AppsSubcategoryCard.vue?vue&type=template&id=dced7f9a&"
import script from "./AppsSubcategoryCard.vue?vue&type=script&lang=js&"
export * from "./AppsSubcategoryCard.vue?vue&type=script&lang=js&"
import style0 from "./AppsSubcategoryCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports